/** The states of a notification. Decides the notifications apperance */
export enum NotificationStates {
    Success = 0,
    Error = 1,
    Warning = 2,
    Info = 3
}
